import { z } from 'zod';

/**
 * Lenient version of PLACE_INPUT that accepts `null` as well as `undefined`.
 * After a JSON round-trip through sessionStorage, `undefined` values are
 * stripped while `null` values are preserved. The strict form-level
 * PLACE_INPUT uses `.optional()` which rejects `null`, so we use a dedicated
 * schema here to tolerate both.
 */
const sessionPlaceInput = z.object({
    addressID: z.string().nullish(),
    latitude: z.number().nullish(),
    longitude: z.number().nullish(),
    region: z.string().nullish(),
    suburb: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish(),
    postCode: z.string().nullish(),
});

export const enquiryFormSessionSchema = z.object({
    name: z.string().trim().min(1),
    email: z.string().trim().email(),
    phoneNumber: z.string().trim().min(1),
    postcode: z.object({ header: z.string(), value: sessionPlaceInput }),
    branchId: z.number().int().positive().nullish(),
    buildHubId: z.number().int().positive().nullish(),
    message: z.string().trim().min(1),
    siteTreeId: z.number().int().positive(),
    source: z.enum([
        'InPage',
        'EnquiryModal',
        'ProfessionalIsland',
        'ProductIsland',
        'ProjectIsland',
        'ProjectTeam',
        'ProjectDetail',
        'ProductHeaderCTA',
        'ProductDetailsCTA',
    ]),
    professional: z.object({
        ID: z.number().int().positive(),
        Title: z.string(),
    }),
    itemType: z.enum(['professional', 'product', 'project', 'article']),
    relatedItem: z
        .object({
            id: z.number().int().positive(),
            type: z.enum(['project']),
            title: z.string(),
            category: z.string(),
        })
        .nullish(),
    files: z
        .array(
            z.object({
                name: z.string(),
                type: z.string(),
                size: z.number(),
                lastModified: z.number(),
            }),
        )
        .nullish(),
    isModal: z.boolean().default(false),
});
